export const DEFAULT_ORDER_CURRENCY = 'EUR';

export interface PriceCurrencyCarrier {
  priceCurrency?: string | null;
}

/** First line item whose currency is not EUR; otherwise EUR. */
export function resolveOrderCurrency(products: PriceCurrencyCarrier[]): string {
  const foreign = products.find((p) => {
    const code = (p?.priceCurrency || DEFAULT_ORDER_CURRENCY).toUpperCase();
    return code !== DEFAULT_ORDER_CURRENCY;
  });
  return (foreign?.priceCurrency || DEFAULT_ORDER_CURRENCY).toUpperCase();
}

/** Resolve from an ordered list of ISO currency codes (e.g. from backend joins). */
export function resolveOrderCurrencyFromCodes(codes: (string | null | undefined)[]): string {
  const foreign = codes.find((code) => {
    const normalized = (code || DEFAULT_ORDER_CURRENCY).toUpperCase();
    return normalized !== DEFAULT_ORDER_CURRENCY;
  });
  return (foreign || DEFAULT_ORDER_CURRENCY).toUpperCase();
}
